import Vue from "vue";
import Vuex from "vuex";
import settings from "./modules/settings";
import getters from "./getters";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    processConditions: [], // processConditions 用于传递流程图需要的条件
    formItemList: [] // 流程节点表单权限控制——组件列表
  },
  modules: {
    settings,
  },
  getters
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js